import {
  AuditVideo,
  GetVideoReviewProgressResBody,
  RISK_LEVEL
} from '@/schemas/video-review';
import VideoReview from '@/services/video-review';

interface CardState {
  auditVideo: AuditVideo;
  pos: { x: number; y: number; rotation: number };
  isAddAnimation?: boolean;
  isSubmiting?: boolean;
}

interface IState {
  // 尝试用该变量来存储多张卡片的位置状态
  cardStates: CardState[];
  previewPictures: string[];
  reviewPopupState: {
    riskLevel: RISK_LEVEL;
    riskSuggestion: string;
    videoContentType: string;
    highQualityVideo?: boolean;
  };
  progress: GetVideoReviewProgressResBody;
}

const videoReview = {
  state: {
    cardStates: [] as CardState[],
    previewPictures: [],
    reviewPopupState: {
      riskLevel: RISK_LEVEL.NONE,
      riskSuggestion: '',
      videoContentType: ''
    },
    progress: {
      auditCount: 0,
      rejectVideoCount: 0,
      currentMonthRank: 0,
      history: []
    }
  } as IState,

  reducers: {
    updateState(state: IState, payload: Partial<IState>) {
      return {
        ...state,
        ...payload
      };
    }
  },
  effects: () => ({
    async getVideoReviewProgress() {
      try {
        const res = await VideoReview.getVideoReviewProgress();
        this.updateState({
          progress: res
        });
      } catch (err) {
        //
      }
    }
  })
};

export default videoReview;
